<template>
  <section class="heim-dashboard-list"><slot /></section>
</template>

<script>
export default {
  name: "heim-dashboard-list"
};
</script>

<style scoped>
.heim-dashboard-list .list-ctn {
  transform: translateX(-1%);
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
</style>
